import LicenseLists from '../components/LicenseLists'
import About from '../components/About'
import Login from '../components/Login'
import AllLicenses from '../components/AllLicenses'
import License from '../components/License'
import EasyAllocation from '../components/EasyAllocation'
import AllAssets from '../components/AllAssets'
import Email from '../components/Email'
import LicenseChecker from '../components/license-checker'

export default [
  {
    // non-protected route to handle application authentication
    path: '/login/:hasEditRole?',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    // protected route to application home component
    path: '/',
    name: 'AllAssets',
    component: AllAssets,
    meta: { requiresAuth: true }
  },
  {
    // protected route to application about component
    path: '/about',
    name: 'About',
    component: About,
    meta: { requiresAuth: true }
  },
  {
    // protected route to application all licenses component
    path: '/licenses/:isNewOrAllocated?/:licenseFromBetaEval?',
    name: 'AllLicenses',
    component: AllLicenses,
    meta: { requiresAuth: true }
  },
  {
    // protected route to application license component
    path: '/license/:licenseId',
    name: 'License',
    component: License,
    meta: { requiresAuth: true }
  },
  {
    path: '/easy/:id',
    name: 'EasyAllocation',
    component: EasyAllocation,
    meta: { requiresAuth: false }
  },
  {
    path: '/manage-licenses',
    name: 'LicenseLists',
    component: LicenseLists,
    meta: { requiresAuth: true }
  },
  {
    path: '/email/:internal?',
    name: 'Email',
    component: Email,
    meta: { requiresAuth: false }
  },
  {
    path: '/la-007',
    name: 'LicenseChecker',
    component: LicenseChecker,
    meta: { requiresAuth: false }
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js